module.exports = __webpack_public_path__ + "img/clickbait.e8daaa7a.svg";